/**
 * 内容专题状态定义和同步
 * @author chenqunfeng
 * @since 17/11/20
 */

import { getUrlWithHttpsProtocol } from '@fe/common/lib/url';
import { SET_CONTENT_TOPIC } from 'constants/action.json5';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTENT_TOPIC: {
      try {
        // 把图片改为https协议
        const data = action.data.data.map(contentTopic => ({
          ...contentTopic,
          url: getUrlWithHttpsProtocol(contentTopic.url),
        }));
        action.data.data = data;

        return {
          ...state,
          ...action.data,
        };
      } catch (e) {
        console.error(e);
        return state;
      }
    }
    default:
      return state;
  }
};
